/* Galerii Perdele — Repară închiderea galeriei foto mărite pe telefon/tabletă
   Pe desktop, un click oriunde pe fundalul ferestrei cu poza mărită o închide
   (revine la mărimea normală). Tema Dawn are acest comportament legat doar de
   mouse ("pointerType === 'mouse'"), deci pe touch (telefon/tabletă) atingerea
   pe fundal nu face nimic — clientul rămâne cu poza mărită și trebuie să
   găsească exact butonul X din colț ca să iasă.
   Aici adăugăm același comportament ("atinge oriunde ca să închizi") și pentru
   touch, identic cu ce se întâmplă deja pe desktop cu click-ul.
   Excludem atingerea direct pe poză (img[data-media-id]), pentru că acolo
   ciupitul/dublu-tap-ul face zoom (vezi gp-modal-zoom.js) — o atingere simplă
   pe poză nu trebuie să închidă fereastra, ca să nu se bată cap în cap cu
   dublu-tap-ul de zoom. Atingerea pe fundalul alb din jurul pozei, sau pe X,
   tot închide fereastra ca înainte. */
document.addEventListener('click', function (event) {
  var modal = event.target.closest('.media-modal[open]');
  if (!modal) return;
  if (event.target.closest('deferred-media, product-model, [id^="ModalClose-"], img[data-media-id]')) return;
  if (typeof modal.hide === 'function') modal.hide();
});
